import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { buildTaskReviewSections } from '../outwrite/outwriteTaskKeyText';

const INK = '#1a1a1a';
const SURFACE = '#fcfcfb';

/**
 * Preview-style text panel for an OutwriteChartTask (tense / difficulty /
 * axis / keyFeatures / prompt). Content comes from buildTaskReviewSections.
 */
export default function OutwriteTaskReviewPanel({ task }) {
  const sections = buildTaskReviewSections(task);

  if (!sections.length) {
    return null;
  }

  return (
    <Box
      component="aside"
      aria-label="Task review key"
      sx={{
        bgcolor: SURFACE,
        border: '1px solid #e4e4e1',
        borderRadius: 1,
        p: 2,
        minHeight: 420,
        overflow: 'auto',
        fontFamily:
          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        fontSize: 12,
        lineHeight: 1.45,
        color: INK,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {sections.map((section, index) => (
        <Box key={section.id} sx={{ mt: index === 0 ? 0 : 1.5 }}>
          {section.title && (
            <Typography
              component="div"
              sx={{
                fontFamily: 'inherit',
                fontSize: 'inherit',
                fontWeight: 700,
                mb: 0.5,
                color: INK,
              }}
            >
              {section.title}
            </Typography>
          )}
          {section.lines.map((line, i) => (
            <Box key={`${section.id}-${i}`}>{line}</Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
